import React from 'react';
import { Truck } from 'lucide-react';

const transportModeOptions = [
  { value: 'None', label: 'Yok' },
  { value: 'Air', label: 'Hava' },
  { value: 'Sea', label: 'Deniz' },
  { value: 'Land', label: 'Kara' }
];

const serviceTypeOptions = [
  { value: 'None', label: 'Yok' },
  { value: 'Delivery', label: 'Teslimat' },
  { value: 'International_Moving', label: 'Yurt dışı Evden Eve Nakliye' },
  { value: 'Origin_Service', label: 'Origin Hizmeti' },
  { value: 'Domestic_Moving', label: 'Yurtiçi Evden Eve Nakliye' },
  { value: 'Domestic_Transportation', label: 'İç Nakliye' },
  { value: 'Storage', label: 'Depolama' }
];

const AccountAdvancedSettingsCard = ({ formData, handleChange }) => (
  <div className="bg-white rounded-3xl p-8 shadow-sm border border-slate-100 space-y-6">
    <div className="pt-4 border-t border-slate-50 space-y-4">
        <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest flex items-center gap-2">
          <Truck size={14} className="text-blue-500" />
          Lojistik Sınıflandırma
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <label className="flex flex-col gap-1">
            <span className="text-[10px] font-black text-slate-400 uppercase ml-1">Lojistik Sektörü</span>
            <select
              name="transportMode"
              value={formData.transportMode || 'None'}
              onChange={handleChange}
              className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold outline-none focus:border-blue-500"
            >
              {transportModeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>

          <label className="flex flex-col gap-1">
            <span className="text-[10px] font-black text-slate-400 uppercase ml-1">Hizmet Türü</span>
            <select
              name="serviceType"
              value={formData.serviceType || 'None'}
              onChange={handleChange}
              className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold outline-none focus:border-blue-500"
            >
              {serviceTypeOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </div>
    </div>
  </div>
);

export default AccountAdvancedSettingsCard;
